import { Component, Input } from '@angular/core';
import { CatalogsService } from 'src/app/shared/services/catalogs.service';
import { IconsService } from 'src/app/shared/services/icons.service';

@Component({
  selector: '[app-tr-invoices]',
  template: `
    <td class="align-middle" style="font-size: 15px !important;">
      <a href="" *ngIf="invoice?.tipo === 0" routerLink="/invoices/{{invoice.id}}">{{invoice?.folio}}</a>
      <a href="" *ngIf="invoice?.tipo === 3 || invoice?.tipo === 6" routerLink="/invoices/{{invoice.primary_invoice_id}}">{{invoice?.folio}}</a>
      <a href="" *ngIf="invoice?.tipo === 5" routerLink="/invoices/{{invoice.id}}">{{invoice?.folio}}</a>
      <a href="" *ngIf="invoice?.tipo === 2" routerLink="/invoices/{{invoice.id}}">{{invoice?.folio}}</a>
    </td>
    <td class="align-middle">{{invoice.uuid}}</td>
    <td class="align-middle">
      <span class="mb-0">{{invoice?.settlement_name}}, {{invoice?.building_name}}, {{invoice?.unit_name}}</span>
    </td>
    <td class="align-middle">{{ invoice?.legal_entity?.business_name || '—' }}</td>
    <td><span class="mb-0 text-sm">{{invoice.created_at | date: 'dd/MM/yyyy - HH:mm'}}</span></td>
    <td>
      <div class="badge badge-pill bg-secondary rounded-5 mb-0 px-3 py-1 me-2">{{ invoiceType?.name }}</div>
      <div class="badge badge-pill bg-warning rounded-5 mb-0 px-3 py-1" *ngIf="invoice?.canceled">Cancelada</div>
      <div class="badge badge-pill bg-success rounded-5 mb-0 px-3 py-1" *ngIf="!invoice?.canceled">Vigente</div>
    </td>
  `,
  styles: ``
})
export class TrInvoicesComponent {
  @Input() invoice: any = null;

  constructor(
    public catalogs: CatalogsService,
    public icons: IconsService,
  ) { }

  get invoiceType() {
    return this.catalogs.tipoFactura.find((x: any) => this.invoice.tipo == x.id);
  }
}
